export enum PlaqueControlRecordChartFields {
  round1PlaqueIndex = 'round1PlaqueIndex',
  round2PlaqueIndex = 'round2PlaqueIndex',
  round1CareIndex = 'round1CareIndex',
  round2CareIndex = 'round2CareIndex',
  nextGoal = 'nextGoal',
  plaqueManagementMethod = 'plaqueManagementMethod',
  result = 'result',
}

export enum Result {
  success = 'success',
  failure = 'failure',
}

export const ResultLabel = {
  [Result.success]: '달성',
  [Result.failure]: '실패',
};

export const PlaqueControlRecordChartFormDefaultValues = {
  [PlaqueControlRecordChartFields.round1PlaqueIndex]: [],
  [PlaqueControlRecordChartFields.round2PlaqueIndex]: [],
  [PlaqueControlRecordChartFields.round1CareIndex]: null,
  [PlaqueControlRecordChartFields.round2CareIndex]: null,
  [PlaqueControlRecordChartFields.nextGoal]: null,
  [PlaqueControlRecordChartFields.plaqueManagementMethod]: '',
  [PlaqueControlRecordChartFields.result]: undefined,
};
